// extracted by mini-css-extract-plugin
export default {"infoMessage":"ArtistSuggestionsItemForm_infoMessage__lusVe","warnMessage":"ArtistSuggestionsItemForm_warnMessage__i+ypb"};